import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';
import vex from 'vex-js';

export default class InspiredComponent extends Component {

  get SELECTORS() {
    return {
      carousel: "#carousel",
      card: "[data-js-card]",
      modal: "[data-js-modal]",
      modalCarousel: "[data-js-modal-carousel]",
      productPin: "[data-js-sku]",
      prevArrow: "[data-js-prev-arrow]",
      nextArrow: "[data-js-next-arrow]",
    };
  }

  readDOM() {
    return {
      carousel: this.$component.querySelector(this.SELECTORS.carousel),
      cards: this.$component.querySelectorAll(this.SELECTORS.card),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      activeCard: null,
      slickInstance: null,
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.trackingComponent = new TrackingComponent();
  }

  importSlick(carousel, options, isMainCarousel = false) {
    const ctx = this;
    const carouselInstance =
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        $(carousel).slick(options);
        if(isMainCarousel) {
          ctx.bindCardClick();
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  handleCardClick(card, cardModal) {
    const ctx = this;
    if (!card.classList.contains('swiping')) {
      cardModal.classList.remove("hidden");
      vex.open({
        unsafeContent: cardModal,
        contentClassName: 'inspired-modal',
        closeClassName: 'icon-close --m',
        showCloseButton: true,
        afterOpen: function () {
          this.closeEl.classList.remove("vex-close");
          // init slick for mobile
          if (window.innerWidth < 768) {
            const cardCarousel = cardModal.querySelector(ctx.SELECTORS.modalCarousel);
            const carouselCards = cardCarousel?.querySelectorAll(".card__modal__product");
            carouselCards?.length === 1 ? carouselCards[0].classList.add("--no-carousel") : '';

            const options = {
              arrows: false,
              centerMode: true,
              centerPadding: carouselCards?.length == 3 ? "100px" : "0",
              slidesToShow: carouselCards?.length == 3 ? 1 : carouselCards.length,
              mobileFirst: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: "unslick"
                },
              ]
            };
            ctx.importSlick(cardCarousel, options);
          }
          //bind pin click
          const pins = cardModal.querySelectorAll(ctx.SELECTORS.productPin);
          pins.forEach(pin => {
            pin.addEventListener("click", ctx.handlePinClick.bind(ctx, pin, cardModal));
          });
          ctx.trackingComponent.inspiredOnLoad();
        },
        beforeClose: function () {
          if (ctx.dom.activeCard) {
            ctx.dom.activeCard.parentNode.classList.remove("--active");
          }
          const pins = cardModal.querySelectorAll(ctx.SELECTORS.productPin);
          pins.forEach(pin => {
            pin.removeEventListener("click", ctx.handlePinClick);
          });
        }
      });
    }
  }

  handlePinClick(pin, modal) {
    const pinSku = pin.dataset.jsSku;
    const carousel = modal.querySelector(this.SELECTORS.modalCarousel);
    if(carousel.slick) {
      // products are in a carousel
      const productCards = modal.querySelectorAll('[data-js-product-sku="' + pinSku + '"]');
      for (const productCard of productCards) {
        const slideIndex = productCard.closest("[data-slick-index]").dataset.slickIndex;
        if(slideIndex >= 0) {
          //index is positive
          carousel.slick.slickGoTo(slideIndex);
          const currentSlide = carousel.querySelector("[data-slick-index='" + carousel.slick.slickCurrentSlide() + "']")
          this.dom.activeCard ? this.dom.activeCard.classList.remove("--active") : '';
          const currentCard = currentSlide.querySelector("[data-js-product-sku]").parentNode;
          currentCard.classList.add("--active");
          this.dom.activeCard = currentCard;
          break;
        }
      }
    } else {
      const productCard = modal.querySelector('[data-js-product-sku="' + pinSku + '"]').parentNode;
      if(productCard) {
        this.dom.activeCard ? this.dom.activeCard.classList.remove("--active") : '';
        productCard.classList.add("--active");
        this.dom.activeCard = productCard;
      }
    }
  }

  bindCardClick() {
    this.dom = this.readDOM();
    const dragEndEvents = ['mouseup', 'touchend'];
    if(this.dom.cards) {
      this.dom.cards.forEach(card => {
        const cardModal = card.querySelector(this.SELECTORS.modal);
        if(cardModal) {
          // avoid modal opening after carousel swipe action
          card.addEventListener("dragstart", (e) => {
            // add control class if swiping carousel
            card.classList.add("swiping");
          });
          // both mouse and touch
          dragEndEvents.forEach((dragEndEvent) => {
            card.addEventListener(dragEndEvent, () => {
              // on "dragend", remove control class after click event is handled (they're parallel)
              setTimeout(() => {
                  if (card.classList.contains("swiping")) {
                    card.classList.remove("swiping");
                  }
                }
              , 400);
            });
          });
          card.addEventListener("click", (event) => {
            this.handleCardClick(card, cardModal);
          });
        }
      });
    }
  }

  initMainSlick() {
    const cardNumber = this.dom.cards.length;
    //hide arrows on desktop
    if(cardNumber <= 4 ) {
      this.dom.prevArrow.remove();
      this.dom.nextArrow.remove();
      this.dom.prevArrow = null;
      this.dom.nextArrow = null;
    }
    if(this.$component.dataset.editMode !== "true") {
      const options = {
        centerMode: true,
        slidesToShow: 1,
        mobileFirst: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: true,
              prevArrow: this.dom.prevArrow,
              nextArrow: this.dom.nextArrow,
              slidesToShow: cardNumber <= 4 ? cardNumber : 4,
              centerPadding: "80px",
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 2,
              centerPadding: "30px",
            }
          },
        ]
      };
      this.importSlick(this.dom.carousel, options, true);
    }
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    if(this.$component.dataset.editMode === "true") {
      this.bindCardClick();
    }
    this.initMainSlick();
  }
}
